import httpClient from '../client/httpClient';
import generateAvatarImage from './generateAvatarImage';

export default async function getSellerData(sellerId) {
    const sellerDataRes = await httpClient.get(`/v1/api/seller/get-by-id/${sellerId}`);
    const { id, shopInfo, imagePath } = sellerDataRes.data;

    const seller = {
        id: id,
        name: shopInfo.shopName
    };

    const avatarImage = generateAvatarImage(seller.name);

    return {
        ...seller,
        image: !imagePath ? avatarImage : imagePath,
        type: "seller"
    };
}
